import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import { ApplicationsAPI, BusinessDBAPI } from '../../components/apis';
import { useSelector } from 'react-redux';
import Loading from '../../components/common/Loading';
import { message } from '../../components/common/Notification';
import { useisLoading } from '../../hook/useisLoading';
import ErrorMessage from '../../components/common/ErrorMessage';
import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import { ButtonsSaveAndCancel } from '../../components/common/ButtonsSaveAndCancel';
import InputField from '../../components/common/InputField';
import Checkbox from '../../components/common/Checkbox';
import { isAlphanumeric, isIP, isPort, isURLsList } from '../../components/common/Util';
import SelectCombobox from '../../components/common/SelectCombobox';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { helperConfirmationAlert } from '../../components/helpers/helperConfirmationAlert';
import types from '../../types/types';
import ButtonDelete from '../../components/common/ButtonDelete';

export const EditApplication = (props, context) => {
    
    console.log("Enter into EditApplication.js...")
    
    const { user, token } = useSelector(state => state.user);
    const { accounts } = useSelector(state => state.accounts);
    
    const [apiApplications, setApiApplications] = useState(null);
    const [apiBusinessDB, setApiBusinessDB] = useState(null);

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading();

    const [isConfirmingVPN, setIsConfirmingVPN] = useState(false)

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
        defaultValues: {
            // Application default attribute for new entity creation
            id: props.id, 
            account_name: null, // Is loadead from useEffect after retrive account object from Redux.
            account_id: props.idAccount,
            enabled: true,
            name: "",
            descripction: "",
            callbacks: "",
            cors: "",            
            allowed_origins: "",
            web_origins: "",

            db_id: null,

            public_IP_address: "",
            private_IP_address: "",
            private_IP_address_ranges: "", // Network types

            private_PORT: "",
            public_IP_sinexiar: "",
            private_IP_sinexiar: "",
            
            pre_shared_key: null,
            
            withVPN: false,
            // Uses to load the list of business database of Account
            businessdb_list: null,
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
            // To redirect after save changes.
            goToAccountHome: false,
        }
    });


    // Load Account's application in order to retrive its "name"
    useEffect(() => {
        
        if (accounts){
            const account = accounts.filter(accountElement => {
                if (accountElement.id === Number(props.idAccount)){
                    return accountElement;
                }
            });
            setValue("account_name", account[0].name);
        }

    }, [accounts]);
    

    // Get API Object for Applications
    useEffect(() => {

        if (token) {
            setApiApplications(new ApplicationsAPI(token, props.idAccount));
        }        

    }, [token])
    
    // Get API Object for Business Database
    useEffect(() => {

        if (token) {
            setApiBusinessDB( new BusinessDBAPI(token, props.idAccount));
        }

    }, [token])

    useEffect(() => {
        showSpinner();
        
        if (apiApplications) {
            apiApplications.get(props.id).then( application => {
                
                setValue("id", application.id);
                setValue("enabled", application.enabled);
                setValue("name", application.name);
                
                setValue("description", application.description);
                setValue("callbacks", application.callbacks);
                setValue("cors", application.cors);

                setValue("allowed_origins", application.allowed_origins);
                setValue("web_origins", application.web_origins);
                
                setValue("db_id", Number(application.application_dbs_links[0].db_id).toString());
            }).catch( err => {
                console.log(err);
                setValue(types.ERROR, context.t("There was a problem on our end. Please try again later."));
            }).finally(() => {
                hideSpinner();
            });
        }

    }, [apiApplications])

    // Load Business Databases
    useEffect(() => {
        
        if (apiBusinessDB) {
            showSpinner();
                
            apiBusinessDB.getAll().then(dbs => {
                // setBusinessDatabases(dbs);
                setValue("businessdb_list", dbs);
                
            }).catch(err => {                
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError",  err.message );
                
            }).finally(()=>{                
                hideSpinner();
            });
        }

    }, [apiBusinessDB])
    
    // Function calls at form submit
    const onSubmit = data => {
        
        console.log("Form has been validated correctly")
        
        // Show spinner
        showSpinner();
        
        // Create "new application objet"
        debugger
        const application = {
            "id": getValues().id,
            "name": getValues().name,
            "account_name": getValues().account_name,
            "account_id": getValues().account_id,
            "description": getValues().description,
            "callbacks": getValues().callbacks,
            "allowed_origins": getValues().allowed_origins,
            "cors": getValues().cors,            
            "enabled": getValues().enabled,
            "web_origins": getValues().web_origins,
            "db_id": Number(getValues().db_id),

            // TODO Complete with VPN parameters when new backend service exists

        };

        apiApplications.update(application).then((app) => {
            console.log("Application has been updated");
            // We set goToAccountHome state in "true" in order to redirect the user to his account after remove the aplication
            setValue("goToAccountHome",  true );
            
            message(context.t("Update Application"), context.t("Application ({app}) was updated successfully", {app: getValues().name}));
            //return app;
        }).catch(err => {
            // Set "backendError" show a back-end error as message to the user at the top.
            setValue(types.ERROR,  err.message );
        }).finally( () =>{
            // Stop spinnner and render page.
            hideSpinner();
        });

    };

    // Handle user action to show alert message and confirm if a VPN connection between Sinexiar and the Customer's infrastructure is necessary.
    const hasVPN = () => {
        setValue("withVPN", true); // This attribute is to force validation onver VPN form fields 
        setIsConfirmingVPN(true);
    }

    // Inverse action than hasVPN function
    const hasNotVPN = () => {
        setValue("withVPN", false); // This attribute is avoid execute validation onver VPN form fields 
        setIsConfirmingVPN(false);
    }

    // This function calls application delete API to remove it.
    const removeApplication = () => {
        
        showSpinner();
        
        apiApplications.delete(getValues("id")).then(() => {
            console.log("Application has been deleted");
            // We set goToAccountHome state in "true" in order to redirect the user to his account after remove the aplication
            setValue("goToAccountHome", true);

            // TOUSE: Use to notificate fleeting message to the user.
            message(context.t("User notification"), context.t("Application '{app}' has been deleted successfully", {app: getValues().name}));

        }).catch(err => {
            debugger
            // TOUSE: Convention to set "backendError". See component usage searching #REF_ERROR_HANDLER_COMPONENT in this page.
            setValue(types.ERROR,  err.message );
        }).finally( () =>{
            // Stop spinnner and render page.
            hideSpinner();
        });

    }
    
    // Handle the event after the user presses the "Delete Application" button.
    // Show a "confirm dialog" and if the user confirms it, call the "removeApplication" function.
    const handleRemoveApplication = (event) => {
            
        event.preventDefault();
        event.stopPropagation();
        
        helperConfirmationAlert(context, context.t("Warning"), "Are you sure you want to delete the application", context.t("Yes"), context.t("No"), removeApplication , null, getValues().name);
        
    }
   

    // Redirect to User Account home Page. Is used after remove or edit an application.
    if (getValues().goToAccountHome) {
        return <Redirect to={ '/home/' + getValues().account_id } />
    }


    if (isLoading ) {
        return <Loading/>
    } else {
        return (
            <Container fluid>
                {/* #REF_ERROR_HANDLER_COMPONENT: If "backendError" has value, it shows to the user */}
                <ErrorMessage message={getValues().backendError} useFormSetValue={() => setValue}/>
                {/* Page header has Title and Subtite of the page */}
                <PageHeaderStandar title={context.t('Apps')} subtitle={context.t('Edit')} />
                <Card className='snx-card'>
                    <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px" }}>
                        <Row>
                            <Col lg="6">
                                <InputField label={context.t('Name')} name="name" placeholder={context.t('Andromeda')} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("name", { 
                                            required: context.t("This is required"), 
                                            minLength: {
                                                value: 4,
                                                message: context.t("The length of the entered value is incorrect") + " [4-50]",
                                            },
                                            maxLength: {
                                                value: 50,
                                                message: context.t("The length of the entered value is incorrect") + " [4-50]",
                                            },
                                            validate: {
                                                alpha: (v) => isAlphanumeric(v) || context.t("Value must be an alpha character"),
                                            },
                                        })
                                    }
                                />
                            </Col>
                            <Col lg="6">
                                <Checkbox label={context.t('Application status')} vertical name="enabled" useFormRegister= {register("enabled", {})}  />
                            </Col>
                            <Col lg="6">
                                <InputField label={context.t('Description')} name="description" placeholder={context.t('Descriptive summary of the application (RESTful API) that you will create')} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("description", { 
                                            required: context.t("This is required"), 
                                            minLength: {
                                                value: 4,
                                                message: context.t("The length of the entered value is incorrect") + " [4-255]",
                                            },
                                            maxLength: {
                                                value: 255,
                                                message: context.t("The length of the entered value is incorrect") + " [4-255]",
                                            },
                                        })
                                    }
                                />
                            </Col>
                            <Col lg="12">
                                <InputField label={context.t('Callbacks')} name="callbacks" placeholder={context.t('https://sinexiar.com/callback, https://ecu.sinexiar.com/application/authorize')} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("callbacks", { 
                                            required: context.t("This is required"), 
                                            validate: {
                                                callbacksValidation: (v) => isURLsList(v) || context.t("The list of URLs are not formatted correctly or are not separated by commas"),
                                            },
                                        })
                                    }
                                />
                            </Col>
                            <Col lg="12">
                                <InputField label={context.t('Cors')} name="cors" placeholder={'http://localhost:9000/callback, https://domain.com/callback, https://my-site.com'} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("cors", { 
                                            required: context.t("This is required"), 
                                            validate: {
                                                corsValidation: (v) => isURLsList(v) || context.t("The list of URLs are not formatted correctly or are not separated by commas"),
                                            },
                                        })
                                    }
                                />
                            </Col>                            
                            <Col lg="12">
                                <InputField label={context.t('Allowed Origins (CORS)')} name="allowed_origins" placeholder={'http://*sinexiar.com, https://*yourcomercialwebsite.com, https://partner:3000'} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("allowed_origins", { 
                                            required: context.t("This is required"), 
                                            validate: {
                                                corsValidation: (v) => isURLsList(v) || context.t("The list of URLs are not formatted correctly or are not separated by commas"),
                                            },
                                        })
                                    }
                                />
                            </Col>                            
                            <Col lg="12">
                                <InputField label={context.t('Allowed Web Origins')} name="web_origins" placeholder={'http://*sinexiar.com, https://*yourcomercialwebsite.com, https://partner:3000'} 
                                    errors={errors} 
                                    useFormRegister= {
                                        register("web_origins", { 
                                            required: context.t("This is required"), 
                                            validate: {
                                                corsValidation: (v) => isURLsList(v) || context.t("The list of URLs are not formatted correctly or are not separated by commas"),
                                            },
                                        })
                                    }
                                />
                            </Col>
                            <Col lg="6">
                                <SelectCombobox
                                    name= "db_id" 
                                    label={ context.t('Business DB') }
                                    valueOptions={ getValues().businessdb_list } 
                                    errors={ errors }
                                    useFormRegister= {
                                        register("db_id", { 
                                            value: Number(getValues().db_id),
                                            required: context.t("Must select an option"),
                                        })
                                    }
                                />
                            </Col>
                            <Col lg="12">
                                <Accordion allowZeroExpanded>
                                    <AccordionItem dangerouslySetExpanded={ isConfirmingVPN } >
                                        <AccordionItemHeading onClick={ () => helperConfirmationAlert(context, context.t("VPN connection"), "Does this app use a VPN connection?", context.t("Yes"), context.t("No"), hasVPN, hasNotVPN) } >
                                            <AccordionItemButton>
                                                {context.t("VPN connection")}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel> 
                                            {(isConfirmingVPN)?(
                                                <Container>
                                                    <Row>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Public IP Address')} name="public_IP_address" placeholder={context.t('192.168.0.1')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("public_IP_address", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isIP(v) || context.t("Invalid IP"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Private IP Address')} name="private_IP_address" placeholder={context.t('10.0.0.1')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("private_IP_address", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isIP(v) || context.t("Invalid IP"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Private IP Address reages')} name="private_IP_address_ranges" placeholder={context.t('10.0.0.0/24')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("private_IP_address_ranges", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isIP(v) || context.t("Invalid IP"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Private PORT')} name="private_PORT" placeholder={context.t('443')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("private_PORT", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isPort(v) || context.t("Invalid PORT"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Sinexiar Public IP')} name="public_IP_sinexiar" placeholder={context.t('192.168.0.1')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("public_IP_sinexiar", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isIP(v) || context.t("Invalid IP"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Sinexiar Private IP')} name="private_IP_sinexiar" placeholder={context.t('10.0.0.0/24')} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("private_IP_sinexiar", { 
                                                                        required: context.t("This is required"),
                                                                        validate: {
                                                                            ip: v => isIP(v) || context.t("Invalid IP"),
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col lg="6">
                                                            <InputField label={context.t('Pre shared key')} name="pre_shared_key" placeholder={"c9a68e83bfd123d144ec5256bc45682accfb8e8f0561f39f44dd388cba9e86f2"} 
                                                                errors={errors} 
                                                                useFormRegister= {
                                                                    register("pre_shared_key", { 
                                                                        required: context.t("This is required"),
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            ):("")}
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col>
                                <ButtonsSaveAndCancel/>
                            </Col>
                            <Col>
                                <ButtonDelete buttonClass='pull-right float-right' onClick={e => { handleRemoveApplication(e) }} />
                            </Col>
                        </Row>
                    </Form>
                </Card>
                <br/>
                <br/>
            </Container>
        )
    }
}


EditApplication.contextTypes = {
    t: PropTypes.func.isRequired
}

export default EditApplication